import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import CustomProductServices from '../api/CustomProductServices';

const initialState = {
  loading: false,
  data: null,
  error: null,
  success: false,
};

export const getCustomProductMethod = createAsyncThunk(`/get-customProduct`, async () => {
  try {
    const { data } = await CustomProductServices.get();
    return data.data;
  } catch (error) {
    console.error('-------', error.message);
    throw error;
  }
});

const customProductSlice = createSlice({
  name: 'customProduct',
  initialState,
  reducers: {},
  extraReducers: {
    // get
    [getCustomProductMethod.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getCustomProductMethod.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
      state.data = payload;
    },
    [getCustomProductMethod.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export default customProductSlice.reducer;
